import HomePage from '@pages/front/Home'
import LoginPage from '@pages/auth/login'
import PhonePage from '@pages/auth/phone'
import RolePage from '@pages/auth/role'
import EmailPage from '@pages/auth/email'
import VerifyPage from '@pages/auth/verify'
import CompleteProfilePage from '@pages/auth/complete'
import ServicePage from '@pages/front/Service'
import AboutUs from '@pages/front/AboutUs'
import Blogs from '@pages/front/Blogs'
import ContactUs from '@pages/front/ContactUs'

const routes = [
  {
    Component: HomePage,
    exact: true,
    index: true,
  },
  {
    Component: LoginPage,
    exact: true,
    path: '/login',
  },
  {
    Component: LoginPage,
    exact: true,
    path: '/admin-login',
  },
  {
    Component: PhonePage,
    exact: true,
    path: '/phone',
  },
  {
    Component: RolePage,
    exact: true,
    path: '/register-as-provider',
  },
  {
    Component: EmailPage,
    exact: true,
    path: '/email',
  },
  {
    Component: VerifyPage,
    exact: true,
    path: '/verify',
  },
  {
    Component: CompleteProfilePage,
    exact: true,
    path: '/register',
  },

  //nav items
  {
    Component: ServicePage,
    exact: true,
    path: '/service',
  },
  {
    Component: AboutUs,
    exact: true,
    path: '/about-us',
  },
  {
    Component: Blogs,
    exact: true,
    path: '/blogs',
  },
  {
    Component: ContactUs,
    exact: true,
    path: '/contact-us',
  },
]

export default routes
